<template>
  <div :class="['ms-select-dicnew', uniListTop ? 'uni-list-top' : '']">
    <div
      :class="[
        'ms-list-cell',
        uniListCellBottom ? 'ms-list-cell-bottom' : '',
        uniListCellTop ? 'ms-list-cell-top' : ''
      ]"
    >
      <div class="ms-list-cell-left">{{ title }}</div>
      <div class="ms-list-cell-db">
        <picker
          class="my-picker"
          :value="index"
          :range="array"
          range-key="value"
          @change="bindPickerChange"
          @cancel="cancel"
        >
          <div class="uni-input" :class="{ 'ms-right-text': showTxt == '请选择' || !showTxt }">
            {{ showTxt }}
          </div>
        </picker>
      </div>
      <div class="ms-arrow">
        <uni-icons :size="16" class="uni-icon-wrapper" color="#bbb" type="arrowright" />
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyValueText, getKeyValue } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    initRighttext: {
      type: Boolean,
      default: true
    },
    uniListCellBottom: {
      type: Boolean,
      default: false
    },
    uniListTop: {
      type: Boolean,
      default: false
    },
    uniListCellTop: {
      type: Boolean,
      default: false
    },
    // 父级对象
    parnetIndex: {
      type: [String, Number],
      default: ''
    },
    // 对应的父级对象的key
    parnetDataKey: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    showTxt() {
      return this.rightText && getKeyValueText(this.code, this.rightText)
        ? getKeyValueText(this.code, this.rightText)
        : '请选择'
    }
  },
  data() {
    return {
      array: [],
      index: 0,
      selectedCode: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.array = getKeyValue(val)
          // this.initData()
        }
      },
      immediate: true
    },
    rightText: {
      handler() {
        this.initData()
      },
      immediate: true
    }
  },
  methods: {
    initData() {
      // 备选列表array,传入的rightText可能都是异步情况,两个值改变的时候都要更新初始值
      if (this.array && this.array.length > 0) {
        const index = this.array.findIndex(
          item => item.code == this.rightText || item.value == this.rightText
        )

        if (index !== -1) {
          // step：1
          // 没有查到: 1可能是给的val默认值是错误 2可能是备选列表没有
          this.index = index
          this.selectedCode = this.array[this.index].code
        } else {
          // step2
          // 没穿值的时候是否默认选中第一个
          if (this.initRighttext) {
            const selectedCode = this.array[0].code
            // 默认选中第一个这时候父组件绑定的rightText的值还不是selectedCode,回调更新一下rightText，走一下step1
            const { parnetIndex, parnetDataKey } = this
            this.$emit('changeDicValue', selectedCode, parnetIndex, parnetDataKey)
            this.$emit('update:rightText', selectedCode)
          } else {
            this.index = 0 // 没有初始默认选中第一个手动重置下拉列表第一个
          }
        }
      } else {
        this.index = 0
        this.selectedCode = this.rightText
      }
    },
    getKeyValueText,
    bindPickerChange: function (e) {
      const index = e.detail.value
      // 更新选中项
      const selectedCode = this.array[index].code
      const { parnetIndex, parnetDataKey } = this
      this.$emit('changeDicValue', selectedCode, parnetIndex, parnetDataKey)
      this.$emit('update:rightText', selectedCode)
      this.$emit('pickerChange', {
        val: selectedCode,
        parnetIndex,
        targetKey: parnetDataKey
      })
    },
    cancel() {
      console.log('cancel2')
    }
  }
}
</script>

<style lang="scss">
.ms-select-dicnew {
  position: relative;

  &.uni-list-top {
    border-top: 0.042667rem solid #c8c7cc;
  }

  .ms-list-cell {
    margin-right: -0.213333rem;
    padding: $uni-spacing-col-lg;
    display: flex;
    align-items: center;
    background-color: #fff;

    .ms-list-cell-left {
      flex: 0 0 auto;
      font-size: $uni-font-size-lg;
      color: #222;
      overflow: hidden;
    }
    .ms-list-cell-db {
      flex: 1;
      display: flex;
      align-items: center;
      overflow: hidden;

      .my-picker {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .uni-input {
        flex: 1;
        text-align: right;

        &.ms-right-text {
          color: #999;
        }
      }
    }
    .ms-arrow {
      flex: 0 0 auto;
      padding-left: 0.213333rem;
    }
  }
}

::v-deep .picker-item {
  font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun;
}
</style>
